import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import FR from "./fr.json";
import EN from "./en.json";
import ES from "./es.json";
import PT from "./pt.json";


const resources = {
  fr: { translation: FR },
  en: { translation: EN },
  es: { translation: ES },
  pt: { translation: PT },
};

// Get saved language from localStorage, fallback to browser or 'fr'
const savedLang = typeof window !== 'undefined' ? localStorage.getItem('tgc-language') : null;
const browserLang = typeof window !== 'undefined' && navigator.language ? navigator.language.split('-')[0] : null;
const initialLang = savedLang || browserLang || 'fr';

i18n.use(initReactI18next).init({
  resources,
  lng: initialLang,
  fallbackLng: "fr",
  interpolation: {
    escapeValue: false,
  },
});

export default i18n;
